module.exports = __webpack_public_path__ + "img/block4-img1.4d69e7fd.svg";